export default __webpack_public_path__ + "static/media/banner02.ee9531d9.png";